module.exports = __webpack_public_path__ + "img/angle_225.84e56808.jpg";